import { render, staticRenderFns } from "./MaterialUpload.vue?vue&type=template&id=59e5d130&scoped=true"
import script from "./MaterialUpload.vue?vue&type=script&lang=js"
export * from "./MaterialUpload.vue?vue&type=script&lang=js"
import style0 from "./MaterialUpload.vue?vue&type=style&index=0&id=59e5d130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e5d130",
  null
  
)

export default component.exports